import { useGlobalState } from "../hooks/useGlobalState"
import { RegisterForm } from "./register/RegisterForm"

export const Modals = () => {
   const { modals } = useGlobalState()

   return (
      <>
         {modals.registerForm && <RegisterForm />}
      </>
   )
}
